import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OutingApprovalRoutingModule } from './outing-approval-routing.module';
import { OutingDashboardComponent } from './outing-dashboard/outing-dashboard.component';
import { OutingLinkComponent } from './outing-link/outing-link.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { OutingHeaderComponent } from './outing-header/outing-header.component';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from "ag-grid-enterprise";
import { environment } from 'src/environments/environment';
import { AgGridModule } from 'ag-grid-angular';
import { OutingApprovalDialogComponent } from './outing-approval-dialog/outing-approval-dialog.component';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from "@progress/kendo-angular-dropdowns";
import { BulkOutingComponent } from './bulk-outing/bulk-outing.component';
import { GatepassOutingComponent } from './gatepass-outing/gatepass-outing.component';
import { SingleOutingRequestComponent } from './single-outing-request/single-outing-request.component';
import { AddFamilyDetailsDialogComponent } from './add-family-details-dialog/add-family-details-dialog.component';
import { PhotoUploadComponent } from './photo-upload/photo-upload.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SecurityApprovalComponent } from './security-approval/security-approval.component';

ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey(environment.ag_grid_key);

@NgModule({
  declarations: [
    OutingDashboardComponent,
    OutingLinkComponent,
    OutingHeaderComponent,
    OutingApprovalDialogComponent,
    BulkOutingComponent,
    GatepassOutingComponent,
    SingleOutingRequestComponent,
    AddFamilyDetailsDialogComponent,
    PhotoUploadComponent,
    SecurityApprovalComponent
  ],
  imports: [
    CommonModule,
    OutingApprovalRoutingModule,
    AcademicFormModule,
    MatSelectModule,
    MatOptionModule,
    AgGridModule,
    NgxSpinnerModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    FormsModule,
    AutoCompleteModule
  ],
  exports: [
    OutingHeaderComponent,
  ]
})
export class OutingApprovalModule { }
